<script>
	import { apiData, apiDataDashboard13036 } from './services/store.js';

	import ProjectTitle from "./components/ProjectTitle.svelte";
	import Row from "./components/Row.svelte";
	import TabWrapper from "./components/TabWrapper.svelte";
    import ApiDevInfo from './components/ApiDevInfo.svelte';

	let name = 'My Project Performance';

</script>

<h1>{name}</h1>
<ProjectTitle
	name={$apiData.name}
/>

<TabWrapper></TabWrapper>


<!-- <Row>
	<div>
		<h2>Debug Information</h2>
		<p>This information will not be shown in production, and is to aid in extracting the content structure.</p>
		
		<ApiDevInfo
			data={$apiDataDashboard13036.body}
			title="My On Site Projects"
			id="13036"
		/>
	</div>
</Row> -->